import './styles';

import React from 'react';

export default class NoDataMessage extends React.Component {
    render() {
        return (
            <div className="NoDataMessage">
                <div className="not-found-logo">
                    <div className="error">404</div>
                    <div className="description">NOT FOUND</div>
                </div>
                <div className="content">
                    {I18n.htmlSafe('not_found', { dimensionsPath: this.props.config.dimensionsPath })}
                </div>
            </div>
        );
    }
}
